import moment from 'moment';

import { IContractCheckoutProcessDTO } from 'modules/customer/domain/dtos';
import IHashProvider from 'shared/domain/providers/IHashProvider';

type TMetaHashValue = {
  dataGeracaoLink?: number;
  origemGeracaoLink?: string;
  usuario?: number;
};
const EMPTY_META_HASH: TMetaHashValue = {
  dataGeracaoLink: undefined,
  origemGeracaoLink: undefined,
  usuario: undefined,
};

type TParams = {
  customerId: number;
  unitId: number;
  meta?: string;
  accounts: number[];
};

export class PendencyCheckoutProcessDTO implements IContractCheckoutProcessDTO {
  public type: IContractCheckoutProcessDTO['type'] = 'CONTRACT';
  public endpoint: IContractCheckoutProcessDTO['endpoint'];

  public unitId: number;
  public accounts: number[];
  private meta?: string;

  constructor(
    { accounts, customerId, unitId, meta }: TParams,
    private hashProvider: IHashProvider,
  ) {
    this.endpoint = `clientes/${customerId}/pagamentoParcelas`;

    this.unitId = unitId;
    this.accounts = accounts;
    this.meta = meta;
  }

  public get body(): IContractCheckoutProcessDTO['body'] {
    const { dataGeracaoLink, origemGeracaoLink, usuario } = this.meta
      ? this.hashProvider.decode<TMetaHashValue>(this.meta)
      : EMPTY_META_HASH;

    const today = moment().format('DD/MM/YYYY HH:mm:ss');

    return {
      contas: this.accounts,
      idUnidade: this.unitId,
      origem: 'SISTEMA',
      dadosLinkPagamentoPendencia: {
        dataHora: dataGeracaoLink || today,
        origem: origemGeracaoLink || 'ECOMMERCE',
        usuario: usuario || null,
      },
    };
  }
}
